import * as React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/styles/app.scss";

const container = document.getElementById("ask-legal-ui");
const root = createRoot(container);
root.render(<App />);